import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { Row, Col, Button } from 'react-bootstrap';
import {
  Form as BaseForm,
  TextField,
  SelectField,
  SubmitButton,
  CancelPopupButton,
} from '../../../ui/FormElement';

import PriceField from './PriceField';
import { usePolicyPlanCustomRecordTemplateContext } from '../../../contexts/PolicyPlanCustomRecordTemplateContext';

export default function Form({
  onSave, onHideModal, typeView, currency,
}) {
  const FormSchema = Yup.object().shape({
    name: Yup.number().typeError('Please, select a Service'),
    price: Yup.string().required('Price is required'),
  });

  const [loader, setLoader] = useState(false);
  const [records, setRecords] = useState(null);

  const { dispatch, state, actions } = usePolicyPlanCustomRecordTemplateContext();

  const [formData, setFormData] = useState({
    name: null,
    price: '',
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    setSubmitting(false);
    setLoader(true);

    const template = state.templates.find(
      (item) => item.attributes.id == values.name,
    );
    if (template != null) {
      onSave({
        name: template.attributes.name,
        price: template.attributes.currency_prices.find((item) => item.currency === currency)?.price,
        currency_prices: template.attributes.currency_prices,
      });
    }
    onHideModal();
  };

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <BaseForm
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      <SelectField
        name="name"
        label={(
          <>
            <span>Service</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder={
          state.templates == null
            ? 'Records are loading ...'
            : 'Select a Service...'
        }
        options={
          state.templates
            ? state.templates.map((item) => ({
              label: item.attributes.name,
              value: item.attributes.id,
            }))
            : null
        }
        menuPlacement="auto"
      />
      <PriceField typeView={typeView} currency={currency} />

      <div className="mt50 mb30">
        <Row>
          <Col md={8}>
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onHideModal}
            />
            {typeView === 'policy' && (
              <a
                className="btn btn-primary btn-outline mr5 ml5 width-120"
                onClick={() => {
                  onSave({
                    name: '',
                    price: '',
                  });
                  onHideModal();
                }}
              >
                Create New
              </a>
            )}
          </Col>
          <Col md={4} className="text-right">
            <SubmitButton
              title={loader ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                loader ? 'not-possible-click' : ''
              }`}
            />
          </Col>
        </Row>
      </div>
    </BaseForm>
  );
}
